import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { CartContext } from '../context/CartContext';
import axios from 'axios';
import '../styles/ProductCard.css';
import Toast from './Toast';
import ButtonRegular from './ui/ButtonRegular';
import ButtonAdditional from './ui/ButtonAdditional';

function ProductCard({ product }) {
	const navigate = useNavigate();
	const { isLoggedIn } = useContext(AuthContext);
	const { fetchCart } = useContext(CartContext);

	const [currentImageIndex, setCurrentImageIndex] = useState(0);
	const [loading, setLoading] = useState(false);
	const [toast, setToast] = useState('');
	const [isFavorite, setIsFavorite] = useState(false);

	const images =
		Array.isArray(product.images) && product.images.length > 0
			? product.images
			: ['https://via.placeholder.com/300x200?text=Brak+zdjecia'];


	// 🔹 Sprawdzenie, czy produkt jest w ulubionych
	useEffect(() => {
		const checkFavorite = async () => {
			if (!isLoggedIn) return;

			try {
				const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/favorites`, {
					headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
				});

				const favorites = res.data.items || [];
				setIsFavorite(favorites.some((fav) => fav.product._id === product._id));
			} catch (error) {
				console.error('Błąd pobierania ulubionych:', error);
			}
		};

		checkFavorite();
	}, [isLoggedIn, product._id]);

	// 🔹 Dodaj/usun z ulubionych
	const handleToggleFavorite = async (e) => {
		e.stopPropagation();

		if (!isLoggedIn) {
			setToast('Musisz być zalogowany, aby dodać produkt do ulubionych.');
			navigate('/login');
			return;
		}

		try {
			if (isFavorite) {
				await axios.delete(
					`${process.env.REACT_APP_API_URL}/api/favorites/remove/${product._id}`,
					{ headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` } }
				);
				setIsFavorite(false);
				setToast('💔 Usunięto z ulubionych');
			} else {
				await axios.post(
					`${process.env.REACT_APP_API_URL}/api/favorites/add`,
					{ productId: product._id },
					{ headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` } }
				);
				setIsFavorite(true);
				setToast('❤️ Dodano do ulubionych!');
			}
		} catch (error) {
			console.error('Błąd ulubionych:', error);
			setToast('❌ Błąd przy modyfikacji ulubionych');
		}
	};

	const handleAddToCart = async (e) => {
		e.stopPropagation();

		if (!isLoggedIn) {
			setToast('Musisz być zalogowany, aby dodać produkt do koszyka.');
			navigate('/login');
			return;
		}

		try {
			setLoading(true);

			await axios.post(
				`${process.env.REACT_APP_API_URL}/api/cart/add`,
				{
					productId: product._id,
					quantity: 1,
				},
				{
					headers: {
						Authorization: `Bearer ${localStorage.getItem('authToken')}`,
					},
				}
			);

			await fetchCart();

			setToast('✅ Produkt dodany do koszyka!');
		} catch (error) {
			console.error('Błąd dodawania do koszyka:', error);
			setToast('❌ Wystąpił błąd przy dodawaniu do koszyka.');
		} finally {
			setLoading(false);
		}
	};

	const handlePrev = (e) => {
		e.stopPropagation();
		setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
	};

	const handleNext = (e) => {
		e.stopPropagation();
		setCurrentImageIndex((prev) => (prev + 1) % images.length);
	};

	const handleDotClick = (index, e) => {
		e.stopPropagation();
		setCurrentImageIndex(index);
	};

	return (
		<div
			className="product-card"
			onClick={() => navigate(`/products/${product._id}`)}
		>
			<div className="carousel-wrapper">
				<div
					className="carousel"
					style={{ transform: `translateX(-${currentImageIndex * 100}%)` }}
				>
					{images.map((img, idx) => (
						<img key={idx} src={img} alt={`product-${idx}`} className="carousel-image" />
					))}
				</div>

				{images.length > 1 && (
					<>
						<button className="arrow left" onClick={handlePrev}>
							&lt;
						</button>
						<button className="arrow right" onClick={handleNext}>
							&gt;
						</button>

						<div className="dots">
							{images.map((_, index) => (
								<span
									key={index}
									className={`dot ${index === currentImageIndex ? 'active' : ''}`}
									onClick={(e) => handleDotClick(index, e)}
								/>
							))}
						</div>
					</>
				)}
			</div>

			<div className="product-info">
				<h3 className="product-name">{product.name}</h3>

				{true && (
					<p className="product-price">
						<strong>Cena:</strong> {Number(product.price).toFixed(2)} PLN
					</p>
				)}

				{true && (
					<div className="product-buttons">
						<ButtonRegular onClick={handleAddToCart} disabled={loading} type="button">{loading ? 'Dodaję...' : 'Dodaj do koszyka'}</ButtonRegular>

						<ButtonAdditional onClick={handleToggleFavorite} type="button">{isFavorite ? '❤️ Usuń z ulubionych' : '🤍 Dodaj do ulubionych'}</ButtonAdditional>
					</div>
				)}
			</div>

			{toast && <Toast message={toast} onClose={() => setToast('')} />}
		</div>
	);
}

export default ProductCard;
